import { sys } from "@/Core/utils/system";
import { fetcher } from "@/api/api";
import useSWR from "swr";
import { useGlobalState } from "./commonStore";
import useSWRMutation from "swr/mutation";
import { IFShareSpin, IFShareSpinInfo } from "@/api/apiRsp/IFShareSpin";


class SWRShareSpinInfoKey {
    //切换法币充值
    public static get getShareSpinInfo() {
        return `getShareSpinInfo?${sys.token}`
    }
}

/**获取分享转盘信息 */
// export const useShareSpinInfo = () => {
//     const fetch = () => {
//         return fetcher<IFShareSpinInfo>({
//             path: '/api/turntable/inviteTurnTableSpinUserInfo',
//             type: 'get',
//         }, {}).then((res: IFShareSpinInfo) => {
//             //
//             return res;
//         })
//     }
//
//     const { isLogin } = useGlobalState()
//
//     return useSWR<IFShareSpinInfo>(isLogin ? SWRShareSpinInfoKey.getShareSpinInfo : null, fetch, {
//         dedupingInterval: 0
//     })
// }

/**获取分享转盘信息 */
export const useShareSpinInfo = () => {
    const fetch = () => {
        return fetcher<IFShareSpinInfo>({
            path: '/api/sharewheel/inviteShareWheelSpinUserInfo',
            type: 'get',
        }, {}).then((res: IFShareSpinInfo) => {
            if (!res || !Object.keys(res).length) {
                throw Object.assign(new Error("Empty invite wheel response"), {
                    code: "ERROR_DATA",
                });
            }
            return res;
        })
    }

    const { isLogin } = useGlobalState()

    return useSWR<IFShareSpinInfo>(isLogin ? SWRShareSpinInfoKey.getShareSpinInfo : null, fetch, {
        dedupingInterval: 0
    })
}

/**分享转盘-旋转抽奖 */
// export const InviteTurnTableSpin = () => {
//     const fetch = () => {
//         return fetcher<IFShareSpin>({
//             path: '/api/turntable/inviteTurnTableSpin',
//             type: 'get',
//         }, {}).then((res: IFShareSpin) => {
//             return res;
//         })
//     }
//     return useSWRMutation<IFShareSpin>('InviteTurnTableSpin', fetch)
// }

/**分享转盘-旋转抽奖 */
export const InviteTurnTableSpin = () => {
    const fetch = () => {
        return fetcher<IFShareSpin>({
            path: '/api/sharewheel/inviteShareWheelSpin',
            type: 'get',
        }, {}).then((res: IFShareSpin) => {
            return res;
        })
    }
    return useSWRMutation<IFShareSpin>('InviteTurnTableSpin', fetch)
}


/**分享转盘-提现 */
// export const InviteTurntableAward = () => {
//     const fetch = () => {
//         return fetcher<any>({
//             path: '/api/turntable/getInviteTurntableAward',
//             type: 'get',
//         }, {}).then((res: any) => {
//             return res;
//         })
//     }
//     return useSWRMutation<any>('InviteTurntableAward', fetch)
// }

/**分享转盘-提现 */
export const InviteTurntableAward = () => {
    const fetch = () => {
        return fetcher<any>({
            path: '/api/sharewheel/getInviteShareWheelAward',
            type: 'get',
        }, {}).then((res: any) => {
            return res;
        })
    }
    return useSWRMutation<any>('InviteTurntableAward', fetch)
}

